import React from 'react';
import { useSteps } from '@workday/upc-common';
import { SendEmailOtpStep } from './send-email-otp-step';
import { VerifyEmailOtpStep } from './verify-email-otp-step';
import { Contact } from '../../../slices/auth-api.slice';
import { RESET_PASSWORD_CHANGE_PASSWORD_PATH } from '../../../react-router-paths';
import { useHistory } from 'react-router-dom';

interface VerifyEmailStepsProps {
    contacts: Array<Contact>;
}

export function VerifyEmailSteps({ contacts }: VerifyEmailStepsProps) {
    const history = useHistory();
    const { currentStep, next } = useSteps();

    function onComplete() {
        history.replace(RESET_PASSWORD_CHANGE_PASSWORD_PATH);
    }

    return currentStep === 0 ? (
        <SendEmailOtpStep onNext={next} contacts={contacts} />
    ) : currentStep === 1 ? (
        <VerifyEmailOtpStep onNext={onComplete} contacts={contacts} />
    ) : null;
}
